"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _addToBasket = require("./addToBasket");
Object.keys(_addToBasket).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addToBasket[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addToBasket[key];
    }
  });
});
var _productBoxClick = require("./productBoxClick");
Object.keys(_productBoxClick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productBoxClick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _productBoxClick[key];
    }
  });
});
